//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { ModalFormMixin } from '@/mixins/ModalFormMixin';
import { getAction, httpAction } from '@api/manage';
import water from "@/views/yongchun/dashboard/com/water.vue";
import { queryBigDataById } from '@api/api';
export default {
  name: 'CompanyModal',
  mixins: [ModalFormMixin],
  components: {
    water: water
  },
  data: function data() {
    return {
      title: '一企一档表单',
      companyId: '',
      siteList: [],
      siteId: '',
      st: ''
    };
  },
  props: ['pagePath'],
  created: function created() {
    this.currentUrl = window.location.href;
  },
  watch: {
    companyId: {
      handler: function handler(value) {
        var _this = this;

        if (value) {
          var params = {
            size: -1,
            current: 1,
            companyId: value
          };
          getAction('site/info', params).then(function (res) {
            if (res.success) {
              _this.siteList = res.result.records;

              _this.siteChange(res.result.records.length > 0 ? res.result.records[0].id : '');
            }
          });
        }
      },
      deep: true
    }
  },
  methods: {
    siteChange: function siteChange(id) {
      var _this2 = this;

      this.siteId = id;

      if (id) {
        var arr = this.siteList.filter(function (item) {
          return item.id === id;
        });
        queryBigDataById({
          id: id
        }).then(function (res) {
          setTimeout(function () {
            _this2.$refs.water.getType({
              siteId: id,
              siteName: '',
              siteType: arr[0].st
            }, res);
          }, 100);
        }).catch(function (e) {
          setTimeout(function () {
            _this2.$refs.water.getType({
              siteId: id,
              siteName: '',
              siteType: arr[0].st
            });
          }, 100);
        });
      }
    }
  }
};